// extracted by mini-css-extract-plugin
module.exports = {"image":"_1Uo4lQ","limitedEdition":"_1xol2C"};